export default __webpack_public_path__ + "static/3.1-332a4490f6940046529ffdc3bb443d55.webp";